import React from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../../lib/api";
import { D, Chip, fmtTime } from "../../ui";

const STATUS = { terkirim: ["green", "Terkirim"], menunggu: ["amber", "Menunggu"], mengirim: ["blue", "Mengirim"], gagal: ["red", "Gagal"], kedaluwarsa: ["red", "Kedaluwarsa"], simulasi: ["gray", "Simulasi"] };
const URUT = ["terkirim", "menunggu", "mengirim", "gagal", "kedaluwarsa", "simulasi"];

// Status kirim balasan komentar (antrean_kirim jenis balas_komentar): ringkasan per status + daftar; kirim ulang untuk gagal/kedaluwarsa
export function BandaraKirim({ token, d, onChanged }) {
  async function ulang(id) {
    try { const r = await api.adminAntreanUlang(token, id); toast.success(r.status === "menunggu" ? "Masuk antrean kirim" : "Dicatat ulang (IG belum tersambung)"); onChanged(); } catch (err) { toast.error(err.message); }
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }} data-testid="bandara-kirim-ringkas">
        {URUT.filter(k => d.ringkas_kirim[k]).map(k => <Chip key={k} tone={STATUS[k][0]} testid={`bandara-ringkas-${k}`}>{STATUS[k][1]} {d.ringkas_kirim[k]}</Chip>)}
        {!Object.keys(d.ringkas_kirim).length && <span style={{ fontSize: 12.5, color: D.sub }}>Belum ada balasan komentar.</span>}
        {!d.tersambung && <span style={{ fontSize: 11.5, color: D.sub, alignSelf: "center" }}>· tanpa kunci Meta, balasan hanya dicatat (simulasi); pekerja mengirim ±2,5/dtk begitu IG tersambung</span>}
      </div>
      <div data-testid="bandara-kirim" style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 300, overflowY: "auto", paddingRight: 2 }}>
        {d.kirim.map(k => {
          const [tone, label] = STATUS[k.status] || ["gray", k.status];
          const bisaUlang = ["gagal", "kedaluwarsa", "simulasi"].includes(k.status);
          return (
            <div key={k.id} data-testid={`bandara-kirim-${k.id}`} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", borderRadius: 14, background: D.cream, fontSize: 12.5 }}>
              <Chip tone={tone}>{label}</Chip>
              <b style={{ color: D.ink, flex: "none" }}>@{k.username}</b>
              <span style={{ color: D.sub, flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={k.teks}>{k.teks}{k.error ? ` · ${k.error}` : ""}</span>
              {k.percobaan > 0 && <span style={{ color: D.sub, fontSize: 11 }}>×{k.percobaan}</span>}
              <span style={{ color: D.sub, fontSize: 11, flex: "none" }}>{fmtTime(k.dikirim_at || k.created_at)}</span>
              {bisaUlang && <button data-testid={`bandara-ulang-${k.id}`} onClick={() => ulang(k.id)} title="Kirim ulang" style={{ border: 0, background: "#fff", color: D.blue, cursor: "pointer", borderRadius: 99, width: 26, height: 26, display: "grid", placeItems: "center" }}><RotateCcw size={13} /></button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
